import { EventEmitter, Injectable, Output } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class CourseContentMenuService {
  @Output() menuDataChange: EventEmitter<any> = new EventEmitter();
}
